// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  version: 'Dev',
  defaultLanguage: 'ar',
  supportedLanguages: ['en', 'ar'],
  versionCheckURL: '',
  intercomAppId: 'fy6969im',
  sentry: {
    dsn: 'https://6a8f6be12ad247fdb686904ba1d68a43@o998260.ingest.sentry.io/5956884',
    ignoreErrors: [
      /^DatabaseClosedError$/
    ]
  },
  firebase: {
    apiKey: 'AIzaSyAtkJlkEbovtc3kRxyIuWVruCXU-7gSfbk',
    authDomain: 'edarapwa-dev.firebaseapp.com',
    projectId: 'edarapwa-dev',
    storageBucket: 'edarapwa-dev.appspot.com',
    messagingSenderId: '181478020295',
    appId: '1:181478020295:web:d64ff8c356c6a6b0a59ae2'
  },
  shopifyFirebase: {
    apiKey: "AIzaSyA2PXA-y1c1VC3Q5Mp4gwp71PJuRO28cqg",
    authDomain: "edara-shopify-dev.firebaseapp.com",
    projectId: "edara-shopify-dev",
    storageBucket: "edara-shopify-dev.appspot.com",
    messagingSenderId: "331821384001",
    appId: "1:331821384001:web:f278064ea4bfcfdae661c0"
  },
  keycloakConfig: {
    url: 'https://kc-auth.getedara.com',
    realm: 'test-realm',
    clientId: '6ucGVdH2DodXiuTWcH3H4dBoeANdVhvv',
    apiIdentifier: 'https://api.getedara.com'
  },
  /**
   * Origins allowed to embed this app as a product inside the Edara Portal (see [[EmbedService]]).
   * An exact origin match is required — this list is what makes embedded mode, and every message
   * exchanged with the portal, trustworthy. Empty list = the app can never run embedded.
   */
  portalOrigins: [
    // To run the portal locally against this app, add your own dev origin here WITHOUT committing
    // it — this file ships to pwa-dev, and a personal hostname in the deployed allowlist would let
    // that host embed the app. The origin must be a real *.getedara.com name mapped to 127.0.0.1:
    // a loopback literal cannot sign in at all, because the WAF in front of Keycloak rejects any
    // authorization request whose redirect_uri contains one.
    'https://portal.getedara.com'
  ],
  posthog: {
    apiKey: "phc_e4SO9O7DYpUZJGLB19ITo9lmKxSApOwezzFDmyVKP4n",
    apiHost: "https://eu.i.posthog.com"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
